import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    backgroundImage: 'url("/images/highlightBg.webp")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    backgroundPosition: 'center',
    display: 'inline-block',
    px: 0.5,
    zIndex: 1,
  },
  typo: {
    position: 'relative',
    zIndex: 1,
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
